import request from './../utils/request'


export function index(params) {
  	return request({
  	  url: '/partner-clinics',
  	  method: 'get',
        params
  	})
  }

  export function inventory(params) {
    return request({
      url: '/partner-clinics/inventory',
      method: 'get',
      params
    })
  }

  export function inventoryAll(params) {
    return request({
      url: '/partner-clinic/inventory-all',
      method: 'get',
      params
    })
  }

export function show(id) {
    return request({
      url: `/partner-clinics/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/partner-clinics',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/partner-clinics/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/partner-clinics/${id}`,
      method: 'delete',
    })
  }